export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/d952e1a50a45969ba3ad3508ddf4edbd.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">오시는 길</h1>
          <p className="text-lg md:text-xl text-slate-300 leading-relaxed">
            재기목형과 뉴테크의 위치를 안내해드립니다.<br />
            방문 전 연락주시면 더욱 자세한 안내를 받으실 수 있습니다.
          </p>
        </div>
      </div>
    </section>
  );
}
